import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useCurrentCarAnnouncementSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useCurrentCarAnnouncementAuctionPause() {
  const { startListen } = useWebSocketStore()
  const { updateAnnouncementCarData } = useUpdateCar()

  const auctionPause = () => {
    startListen({
      eventName: 'premium.AUCTION_PAUSE',
      callbackName: CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK,
      callback: (event) => {
        const { auctionId } = event.context

        updateAnnouncementCarData(auctionId, (item) => {
          if (!item) {
            return item
          }

          return {
            ...item,
            pausedHotbidStartTime: item.hotbidStartTime,
            hotbidStartTime: null,
          }
        })
      },
    })
  }

  return { auctionPause }
}
